var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAydinlar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,22.3c.3-2.3,1.5-4.1,2.8-5.9,1.1-1.6,2.3-3.2,4-.5.2.4,1,.8,1.4.7,4.3-1.1,9.1-.1,13-2.8,1.8-1.3,3.4-1.6,5.4-.3,1.5,1.1,3.3,1.2,4.9-.2.9-.8,1.9-1.3,3-.7,1.1.7.3,1.8.1,2.7-1.3,5.8-1.4,5.5-7.3,6.3-8.9,1.1-17.9,1.6-27.2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAydinlar);
export default __webpack_public_path__ + "static/media/aydinlar.1c2c4572c9ad650c9f329b136f62253e.svg";
export { ForwardRef as ReactComponent };